import React, { useEffect, useState, useCallback } from 'react';
import { tableData } from '../../Data';

import useApi from '../../api/useApi';

function Table() {
  const [{ isLoading, isError, data }, getData] = useApi();
  const [stats, setStats] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [formData, setFormData] = useState({ orgName: '' });
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    getData('/stats/detail', 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setStats(data.stats);
      setFilteredData(data.stats);
      let org = data.stats && data.stats.map((item) => item.organizationName);
      org = [...new Set(org)];
      setOrgs(org);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (stats.length <= 0) {
      return;
    }

    if (formData.orgName === '') {
      setFilteredData(stats);
    }

    let z = stats;

    if (formData.orgName) {
      z = z.filter((item) => item.organizationName === formData.orgName);
    }

    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [formData]);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  return (
    <div className="relative my-2">
      <div style={{ minWidth: '900px' }}>
        <div className="bg-white w-tableWidth m-auto mb-3">
          <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
            <div className="px-8 py-2 items-center flex w-full relative bg-primary text-white text-left text-xs font-bold">
              <div className=" py-1 w-1/4">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-3 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.orgName}
                    name="orgName"
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">ORGANIZATION NAME</option>
                    {orgs?.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-1/4">PROJECT NAME</div>
              <div className="w-1/4">BLE GATEWAYS</div>
              <div className="w-1/4">BLE TAGS</div>
              <div className="w-1/4">CAT-M1 TAGS</div>
              {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
            </div>
          </div>
          <div className="hideScroll" style={{ overflowY: 'scroll', height: '55vh' }}>
            {filteredData?.map((item) => {
              return (
                item.Project.map((x) => {
                    return (
                    <div
                      className="my-1 px-8 flex
                    relative hover:border-indigo-200 focus-within:border-indigo-200 text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                        <div className="w-1/4">{item.organizationName}</div>
                        <div className="w-1/4">{x === null ? '---' : x.projectName}</div>
                        <div className="w-1/4"> {x === null ? '---' : x.bleGateway}</div>
                        <div className="w-1/4"> {x === null ? '---' : x.bleTags}</div>
                        <div className="w-1/4"> {x === null ? '---' : x.catM1Tag}</div>
                        </div>
                    );
                  })
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Table;
